import { TILE_TYPES, TRAFFIC_OVERLAY_URLS } from '../tiles/constants';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  type: TILE_TYPES.VECTORHARP,
  isActive: false,
  raster: {
    // host: 'https://tiles.traffic.api.here.com/traffic/6.0/tiles',
    url: 'traffic.maps.hereapi.com',
    path: '/v3/flow/mc/',
    imagesize: '256',
    imageformat: 'png',
    profile: '',
    apiKey: window.APIKEY,
    extraparams: '',
    refreshInterval: 60,
  },
  vector: {
    url: TRAFFIC_OVERLAY_URLS[0],
    path: '/v2/traffictiles/traffic/mc/',
    apiKey: window.APIKEY,
    refreshInterval: 60,
  },
  vectorHARP: {
    url: TRAFFIC_OVERLAY_URLS[0],
    path: '/v2/',
    apiKey: window.APIKEY,
    refreshInterval: 60,
  },
};
